import { Country } from "@libs/enums/country.enum.ts";
import {
  CommunicationDto,
  CommunicationType
} from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import {
  email,
  phone,
  phoneAdditionalValidation,
  predicate,
  required,
  url
} from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

export class CommunicationValidator extends Validator<CommunicationDto> {
  isRequired: boolean;
  constructor(country: Country, isRequired?: boolean) {
    super();
    this.isRequired = !!isRequired;

    this.forField("value", [
      predicate(
        (_val, comm) =>
          comm?.type !== CommunicationType.Email &&
          comm?.type !== CommunicationType.Website &&
          !!comm?.value,
        phone
      ),
      (_val, comm) => {
        return (
          comm.value &&
          comm?.type !== CommunicationType.Email &&
          comm?.type !== CommunicationType.Website &&
          phoneAdditionalValidation(comm.value, country)
        );
      },
      predicate(() => this.isRequired, required())
    ]);

    this.forField("value", [
      predicate(
        (val: string, comm: CommunicationDto) =>
          comm.type === CommunicationType.Email && !!comm.value,
        email(),
        predicate(() => this.isRequired, required())
      )
    ]);

    this.forField("value", [
      predicate(
        (val: string, comm: CommunicationDto) =>
          comm.type === CommunicationType.Website && !!comm.value,
        url(),
        predicate(() => this.isRequired, required())
      )
    ]);
  }
}
